import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'center',
  padding: (p) => p.spacing(3),
  borderRadius: (p) => p.spacing(1),
  background: 'linear-gradient(to right, #F7F2FE 17.93%, #EBEFFE 95.46%)',
  maxWidth: (p) => p.spacing(150),
  width: '100%',
  mx: 'auto',
};

export const title: SxStyle = {
  background: `linear-gradient(to right, #3558B9 0%, #323232 100%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

export const card: SxStyle = {
  padding: (p) => p.spacing(1.25),
  boxShadow: 'none',
  gap: (p) => p.spacing(0.5),
};

export const skeleton: SxStyle = {
  height: (p) => p.spacing(3),
  width: (p) => p.spacing(6),
};
